import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function CookiePolicyPage() {
  const { t } = useLang();

  const openPreferences = () => window.dispatchEvent(new Event('open-cookie-preferences'));

  const sections = [
    {
      title: { it: '1. Cosa sono i cookie', en: '1. What are cookies' },
      text: {
        it: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Questa Cookie Policy è resa ai sensi del Reg. UE 2016/679 (GDPR) e delle Linee Guida del Garante per la Protezione dei Dati Personali del 10 giugno 2021.",
        en: 'Cookies are small text files that websites send to the user\'s device, where they are stored and sent back to the same sites on the next visit. This Cookie Policy is provided pursuant to EU Reg. 2016/679 (GDPR) and the Italian Data Protection Authority Guidelines of 10 June 2021.',
      },
    },
    {
      title: { it: '2. Cookie tecnici (necessari)', en: '2. Technical cookies (necessary)' },
      text: {
        it: "Questi cookie sono indispensabili per il funzionamento del sito e non richiedono consenso (art. 122 Codice Privacy): gestione della sessione di navigazione, autenticazione dell'account (access_token, refresh_token), carrello degli acquisti, preferenza lingua e memorizzazione delle scelte sui cookie. Durata: sessione o massimo 7 giorni.",
        en: 'These cookies are essential for the site to work and do not require consent: browsing session management, account authentication (access_token, refresh_token), shopping cart, language preference and storage of cookie choices. Duration: session or up to 7 days.',
      },
    },
    {
      title: { it: '3. Cookie statistici (Google Analytics)', en: '3. Analytics cookies (Google Analytics)' },
      text: {
        it: "Solo con il tuo consenso esplicito utilizziamo Google Analytics 4 (Google Ireland Ltd.) per raccogliere statistiche aggregate sull'utilizzo del sito (pagine visitate, provenienza del traffico, dispositivo). L'indirizzo IP è anonimizzato. I dati possono essere trasferiti negli USA sulla base del EU-US Data Privacy Framework. Senza il tuo consenso, questi cookie non vengono installati. Maggiori informazioni: https://policies.google.com/privacy. Durata massima: 24 mesi.",
        en: 'Only with your explicit consent do we use Google Analytics 4 (Google Ireland Ltd.) to collect aggregate statistics on site usage (pages visited, traffic sources, device). IP addresses are anonymized. Data may be transferred to the USA under the EU-US Data Privacy Framework. Without your consent, these cookies are not installed. More info: https://policies.google.com/privacy. Maximum duration: 24 months.',
      },
    },
    {
      title: { it: '4. Cookie di terze parti per i pagamenti', en: '4. Third-party payment cookies' },
      text: {
        it: 'Durante il checkout, i provider di pagamento Stripe e PayPal possono installare cookie tecnici necessari alla sicurezza della transazione e alla prevenzione delle frodi. Questi cookie sono gestiti direttamente dai rispettivi provider: Stripe (https://stripe.com/privacy) e PayPal (https://www.paypal.com/privacy).',
        en: 'During checkout, payment providers Stripe and PayPal may install technical cookies necessary for transaction security and fraud prevention. These cookies are managed directly by the respective providers: Stripe (https://stripe.com/privacy) and PayPal (https://www.paypal.com/privacy).',
      },
    },
    {
      title: { it: '5. Come gestire le tue preferenze', en: '5. How to manage your preferences' },
      text: {
        it: "Puoi modificare o revocare il consenso in qualsiasi momento cliccando su \"Preferenze Cookie\" nel footer del sito. Puoi inoltre eliminare i cookie già installati dalle impostazioni del tuo browser (Chrome, Safari, Firefox, Edge). La revoca del consenso non pregiudica la liceità del trattamento effettuato prima della revoca.",
        en: 'You can change or withdraw your consent at any time by clicking "Cookie Preferences" in the site footer. You can also delete cookies already installed from your browser settings (Chrome, Safari, Firefox, Edge). Withdrawing consent does not affect the lawfulness of processing carried out before the withdrawal.',
      },
    },
    {
      title: { it: '6. Titolare del trattamento', en: '6. Data controller' },
      text: {
        it: 'Il titolare del trattamento è biolosophy, Via Ofanto 24, 59100 Prato (PO), Italia — P.IVA IT08028200965 — email: info@biolosophy.it. Per l\'informativa completa sul trattamento dei dati personali consulta la Privacy Policy.',
        en: 'The data controller is biolosophy, Via Ofanto 24, 59100 Prato (PO), Italy — VAT no. IT08028200965 — email: info@biolosophy.it. For full information on personal data processing, see the Privacy Policy.',
      },
    },
  ];

  return (
    <div data-testid="cookie-policy-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-3xl">
          <p className="overline mb-4">{t({ it: 'Legale', en: 'Legal' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-4">
            Cookie Policy
          </h1>
          <p className="text-sm text-[#57534E] mb-8">
            {t({
              it: 'Ultimo aggiornamento: settembre 2026 — ai sensi del Reg. UE 2016/679 (GDPR)',
              en: 'Last updated: September 2026 — pursuant to EU Reg. 2016/679 (GDPR)',
            })}
          </p>
          <button
            onClick={openPreferences}
            data-testid="open-cookie-preferences-btn"
            className="btn-primary mb-16"
          >
            {t({ it: 'Gestisci Preferenze Cookie', en: 'Manage Cookie Preferences' })}
          </button>

          <div className="space-y-10">
            {sections.map((s) => (
              <div key={s.title.it}>
                <h2 className="text-lg font-medium text-[#1C1917] mb-3">{t(s.title)}</h2>
                <p className="text-sm text-[#1C1917]/70 leading-relaxed">{t(s.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
